import React, { useState } from "react";

export default function LifecycleTabs({ data }) {

  const [activeTab, setActiveTab] = useState("procurement");

  const procurement = data?.procurement || {};
  const receiving = data?.receiving || {};
  const reservation = data?.reservation || {};
  const consumption = data?.consumption || {};

  return (

    <div className="lifecycle-tabs">

      {/* TAB HEADER */}
      <div className="tab-header">

        <button
          className={activeTab === "procurement" ? "active" : ""}
          onClick={() => setActiveTab("procurement")}
        >
          Procurement
        </button>

        <button
          className={activeTab === "receiving" ? "active" : ""}
          onClick={() => setActiveTab("receiving")}
        >
          Receiving
        </button>

        <button
          className={activeTab === "reservation" ? "active" : ""}
          onClick={() => setActiveTab("reservation")}
        >
          Reservation
        </button>

        <button
          className={activeTab === "consumption" ? "active" : ""}
          onClick={() => setActiveTab("consumption")}
        >
          Consumption
        </button>

      </div>

      {/* PROCUREMENT TAB */}
      {activeTab === "procurement" && (

        <div>

          <h4>Purchase Orders</h4>

          {procurement.purchase_orders?.length === 0 ? (
            <p>No Purchase Orders found</p>
          ) : (

            <table className="lifecycle-table">
              <thead>
                <tr>
                  <th>PO Number</th>
                  <th>Created Date</th>
                </tr>
              </thead>

              <tbody>

                {procurement.purchase_orders.map((po) => (

                  <tr key={po.id}>
                    <td>{po.po_number}</td>
                    <td>{new Date(po.created_at).toLocaleString()}</td>
                  </tr>

                ))}

              </tbody>
            </table>

          )}

        </div>

      )}

      {/* RECEIVING TAB */}
      {activeTab === "receiving" && (

        <div>

          <h4>GRNs</h4>

          {receiving.grns?.length === 0 ? (
            <p>No GRNs found</p>
          ) : (

            <table className="lifecycle-table">

              <thead>
                <tr>
                  <th>GRN Number</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>

                {receiving.grns.map((grn) => (

                  <tr key={grn.id}>
                    <td>{grn.grn_number}</td>
                    <td>{grn.status}</td>
                    <td>{new Date(grn.created_at).toLocaleString()}</td>
                  </tr>

                ))}

              </tbody>

            </table>

          )}

          <h4 style={{ marginTop: "20px" }}>Incoming Quality</h4>

          {receiving.incoming_quality?.length === 0 ? (
            <p>No Quality Inspections</p>
          ) : (

            <table className="lifecycle-table">

              <thead>
                <tr>
                  <th>Inspection No</th>
                  <th>Status</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>

                {receiving.incoming_quality.map((iq) => (

                  <tr key={iq.id}>
                    <td>{iq.inspection_number}</td>
                    <td>{iq.status}</td>
                    <td>{new Date(iq.created_at).toLocaleString()}</td>
                  </tr>

                ))}

              </tbody>

            </table>

          )}

        </div>

      )}

      {/* RESERVATION TAB */}
      {activeTab === "reservation" && (

        <div>

          <h4>Reservations</h4>

          {reservation.reservations?.length === 0 ? (
            <p>No reservations found</p>
          ) : (

            <table className="lifecycle-table">

              <thead>
                <tr>
                  <th>Reservation ID</th>
                  <th>Reserved Qty</th>
                  <th>Issued Qty</th>
                </tr>
              </thead>

              <tbody>

                {reservation.reservations.map((res) => (

                  <tr key={res.reservation_id}>
                    <td>{res.reservation_id}</td>
                    <td>{res.reserved_quantity}</td>
                    <td>{res.issued_quantity}</td>
                  </tr>

                ))}

              </tbody>

            </table>

          )}

        </div>

      )}

      {/* CONSUMPTION TAB */}
      {activeTab === "consumption" && (

        <div>

          <h4>Material Issues</h4>

          {consumption.issues?.length === 0 ? (
            <p>No issues found</p>
          ) : (

            <table className="lifecycle-table">

              <thead>
                <tr>
                  <th>Reference</th>
                  <th>Quantity</th>
                  <th>Date</th>
                </tr>
              </thead>

              <tbody>

                {consumption.issues.map((issue, i) => (

                  <tr key={i}>
                    <td>{issue.reference_document_no}</td>
                    <td>{issue.quantity}</td>
                    <td>{new Date(issue.created_at).toLocaleString()}</td>
                  </tr>

                ))}

              </tbody>

            </table>

          )}

        </div>

      )}

    </div>

  );

}